export default "__VITE_ASSET__BJ_UDKa9__"